var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5H8.01M2 5.7L2 10.1745C2 10.6637 2 10.9083 2.05526 11.1385C2.10425 11.3425 2.18506 11.5376 2.29472 11.7166C2.4184 11.9184 2.59135 12.0914 2.93726 12.4373L10.6059 20.1059C11.7939 21.2939 12.388 21.888 13.0729 22.1105C13.6755 22.3063 14.3245 22.3063 14.927 22.1105C15.612 21.888 16.2061 21.2939 17.3941 20.1059L19.6059 17.8941C20.7939 16.7061 21.388 16.112 21.6105 15.427C21.8063 14.8245 21.8063 14.1755 21.6105 13.5729C21.388 12.888 20.7939 12.2939 19.6059 11.1059L11.9373 3.43726C11.5914 3.09135 11.4184 2.9184 11.2166 2.79472C11.0376 2.68506 10.8425 2.60425 10.6385 2.55526C10.4083 2.5 10.1637 2.5 9.67452 2.5L5.2 2.5C4.0799 2.5 3.51984 2.5 3.09202 2.71799C2.7157 2.90973 2.40973 3.21569 2.21799 3.59202C2 4.01984 2 4.57989 2 5.7ZM8.5 8.5C8.5 8.77614 8.27614 9 8 9C7.72386 9 7.5 8.77614 7.5 8.5C7.5 8.22386 7.72386 8 8 8C8.27614 8 8.5 8.22386 8.5 8.5Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsLabel);
export default __webpack_public_path__ + "static/media/as-label.1bb458443661508b870400b6cc31ceb4.svg";
export { ForwardRef as ReactComponent };